// extracted by mini-css-extract-plugin
export default {"grid":"jQdQJ7","container":"nHlGxO","column":"lPd12K","row":"TGmErQ"};